import module from 'viaticos/module.js'
import template from './template.html'

export class ViaticosPagosPendientesComponent {
  filtro = {
    estado: 0,
    general: undefined,
  }

  constructor (ViaticosPagosPendientesService) {
    this.ViaticosPagosPendientesService = ViaticosPagosPendientesService
  }

  $onInit () {
    this.promise = this.ViaticosPagosPendientesService.get()
      .then(({data}) => {
        this.data = data
        this.filtrar()
      })
  }

  filtrar () {
    this.results = this.data
  }

  editar (item, pago) {
    this.data = this.data.map((viatico) => {
      if (viatico.folio === item.folio) {
        viatico.pago = pago
      }
      return viatico
    })
    item.pago = pago
    this.filtrar()
  }
}

module.component('viaticosPagosPendientes', {
  controller: ViaticosPagosPendientesComponent,
  template,
})



// WEBPACK FOOTER //
// ./src/viaticos/components/pagos/pendientes/component.js